import request from '@/service/request';
import type { AmazonAuthorizationCodePorps, LoginProps, AuthStatusProps } from '@/types';

const baseUrl = process.env.NEXT_PUBLIC_API_HOST;

const authUrl = `iot-smart-voice`; //正式环境地址

//const test_authUrl = `iot-smart-voice-test`; // dev环境地址/ test环境地址

// ecoflow账号登陆
export const toLogin = (params: LoginProps) => {
    return request(`${baseUrl}/auth/login`, {
        method: 'POST',
        data: {
            ...params,
        },
    });
};

// 服务商登录
export const proLogin = (params: LoginProps) => {
    return request(`${baseUrl}/auth/provider/login`, {
        method: 'POST',
        data: {
            ...params,
        },
    });
};

export const authSignIn = (data: any) => {
    const { locale, ...rest } = data;
    return request(`${baseUrl}/auth/signIn?locale=${locale}`, {
        method: 'POST',
        data: {
            ...rest,
        },
    });
};

// product type and param configuration
export const getAmazonAuthorizationCode = (params: AmazonAuthorizationCodePorps) => {
    return request(`${baseUrl}/${authUrl}/alexa/v2/oauth/authorize`, {
        method: 'GET',
        params,
    });
};

// 查当前link状态
export const getIotSmartVoiceAuthStatus = ({ thirdType }: AuthStatusProps) => {
    return request(`${baseUrl}/${authUrl}/${thirdType}/v2/oauth/status`, {
        method: 'GET',
    });
};

// unlink取消连接第三方
export const cancelIotSmartVoiceAuthStatus = ({ thirdType }: AuthStatusProps) => {
    return request(`${baseUrl}/${authUrl}/${thirdType}/v2/oauth/unlink`, {
        method: 'GET',
        params: {
            thirdType,
        },
    });
};

// 授权提供authorization code
export const getIotSmartVoiceAuthauthorize = ({ thirdType = 'alexa', ...rest }) => {
    return request(`${baseUrl}/${authUrl}/${thirdType}/v2/oauth/authorize`, {
        method: 'GET',
        params: {
            thirdType,
            ...rest,
        },
    });
};

//三方回跳ecoflow
export const getIotSmartVoiceAuthRedirectUrl = ({ thirdType = 'alexa', ...rest }) => {
    return request(`${baseUrl}/${authUrl}/${thirdType}/v2/oauth/redirectUrl`, {
        method: 'GET',
        params: {
            thirdType,
            ...rest,
        },
    });
};
